export default __webpack_public_path__ + "9152765a61e594d2b04725c93e9da092.gif";